import React from 'react';
import { Container } from 'reactstrap';
import './TermsOfUse.scss';
import foundryImage from '../../../images/foundry1_min.jpg';

const TermsOfUse = () => (
    <Container fluid className="p-0">
        <div className="terms-hero">
            <div className="terms-hero-background" style={{ backgroundImage: `url(${foundryImage})` }} />
            <div className="terms-hero-content">
                <div className="terms-icon">
                    <i className="fa fa-gavel" style={{ color: '#F04E3F', fontSize: '2.5rem' }} />
                </div>
                <h1>Terms of Use</h1>
                <p className="last-updated">Last Updated: 4/30/2025</p>
            </div>
        </div>
        <div className="terms-main-content">
            <div className="terms-content">
                <section>
                    <p>
                        Welcome to ICON, the online platform provided by Non-Ferrous Founders Society | NFFS. By accessing or using our website,
                        you agree to comply with and be bound by the following terms and conditions of use, which together with our privacy policy
                        govern ICON&apos;s relationship with you in relation to this website. If you disagree with any part of these terms and conditions,
                        please do not use our website.
                    </p>
                </section>

                <section>
                    <h2>Acceptance of Terms</h2>
                    <p>
                        By accessing and using ICON, you accept and agree to be bound by the terms and provisions of this agreement.
                        In addition, when using ICON&apos;s particular services, you shall be subject to any posted guidelines or rules applicable to such services.
                    </p>
                </section>

                <section>
                    <h2>Changes to Terms</h2>
                    <p>
                        NFFS reserves the right to change, modify, add, or remove portions of these terms at any time.
                        It is your responsibility to check these terms periodically for changes. Your continued use of the site
                        following the posting of changes will mean that you accept and agree to the changes.
                    </p>
                </section>

                <section>
                    <h2>Use of the Site</h2>
                    <p>
                        You agree to use the site only for lawful purposes and in a way that does not infringe the rights of,
                        restrict, or inhibit anyone else&apos;s use and enjoyment of the site.
                    </p>
                    <p>
                        You must not use the site to transmit or post any material which is defamatory, offensive, or obscene.
                    </p>
                </section>

                <section>
                    <h2>Intellectual Property</h2>
                    <p>
                        All content on this site, including text, graphics, logos, icons, images, and software, is the property of NFFS
                        or its content suppliers and is protected by international copyright laws.
                    </p>
                    <p>
                        You may not reproduce, distribute, or create derivative works from any of the content on this site without
                        the express written consent of NFFS.
                    </p>
                </section>

                <section>
                    <h2>Limitation of Liability</h2>
                    <p>
                        NFFS will not be liable for any damages of any kind arising from the use of this site, including but not limited to
                        direct, indirect, incidental, punitive, and consequential damages.
                    </p>
                    <p>
                        NFFS does not warrant that the site will be uninterrupted or error-free, and NFFS will not be liable for any
                        interruptions or errors.
                    </p>
                </section>

                <section>
                    <h2>Governing Law</h2>
                    <p>
                        These terms and conditions are governed by and construed in accordance with the laws of the United States,
                        and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
                    </p>
                </section>

                <section>
                    <h2>Contact Information</h2>
                    <p>
                        If you have any questions about these Terms of Use, please contact us at <a href="mailto:support@iconportal.com?bcc=support@nffs.atlassian.net&subject=IT%20Support%20Request%20-%20ICON%20Portal&body=Please%20describe%20your%20request%20or%20issue%20below%3A%0A%0A">support@iconportal.com</a>.
                    </p>
                </section>
            </div>
        </div>
    </Container>
);

export default TermsOfUse; 


// WEBPACK FOOTER //
// ./src/pages/static/TermsOfUse/TermsOfUse.jsx